<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
      <div style="width: 90%;margin-top: 3%;" >
          <div >
          <h1 style="text-align: center;">{{ PlaceOforigin.name }}</h1>
          <ol>
            <li v-for="(paragraph, index) in paragraphs"
                :key="index"
                style="margin-left: 20px;line-height: 30px;">
              {{paragraph }}
            </li>
          </ol>
      </div>
    </div>
  </ShowControl>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import ShowControl from "../../UserControl/ShowControl.vue"
  export default {
    props: ["datas"],
    components: {
      ShowControl
    },
    data () {
      return {
        PlaceOforigin: {},
        paragraphs: [],
        flowID: localStorage.getItem("flowID"),
        title: '举办地区数据分析'
      }
    },
    computed: {
      ...mapState({
        Round: (state) => state.user.round,
        ChatShow:(state) => state.user.chatShows,
      }),
    },
    created () {
      this.Checkout(this.$route.query.id)
    },
    mounted(){
      this.$refs.showControl.receiveValue(true);
    },
    methods: {
      revertClick(){
        this.$router.push("/PlaceOfOriginCard")
      },
      Checkout (id) {
        this.$http.get(`Area/GetPlaceOforigin?id=${id}&round=${this.Round}`).then((res) => {
            if (res.success) {
            this.PlaceOforigin = res.dynamicObj;
            this.paragraphs = this.PlaceOforigin.description.split('\n'); // 使用split()方法进行分割
            this.paragraphs = this.paragraphs.filter(item => item.trim() !== '')
            this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.查看产地数据 });  
            this.PlaceOfOriginShow = false
            this.PlaceOforiginDialog = true;
            } else {
            this.$message.error(res.message)
            }
        })
      }
    }
  }
  </script>
  
  <style>
  </style>